/* =====================================================================
   ZZ Fullscreen Menu controller (vanilla)
   - open / close (trigger, close buttons, backdrop, Esc)
   - body scroll lock + focus trap + focus restore
   - desktop mega-switch (hover / click / focus)
   - desktop Produkte category hover → cols B/C swap
   - mobile drill (category → subcategories slide) + back
   Idempotent: safe to load once; re-binds on Shopify section render.
   ===================================================================== */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function init(overlay) {
    if (!overlay || overlay.__zzInit) return;
    overlay.__zzInit = true;

    var shell = overlay.querySelector('.zz-menu__shell');
    var mobile = overlay.querySelector('.zz-menu__mobile');
    var lastFocused = null;
    var transitionMs = prefersReducedMotion() ? 150 : 460;

    /* ---- open / close --------------------------------------------- */
    function open() {
      if (overlay.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zz-menu-open');
      // next frame so the transition runs from the hidden state
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
        });
      });
      // sync triggers
      triggersFor(overlay).forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });
      var focusTarget =
        overlay.querySelector('.zz-menu__close') ||
        overlay.querySelector(FOCUSABLE);
      if (focusTarget) {
        setTimeout(function () { focusTarget.focus(); }, 60);
      }
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zz-menu-open');
      triggersFor(overlay).forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        if (!overlay.classList.contains('is-open')) {
          overlay.hidden = true;
          resetMobileDrill();
        }
      }, transitionMs);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') trapFocus(e);
    }

    function trapFocus(e) {
      var nodes = Array.prototype.filter.call(
        overlay.querySelectorAll(FOCUSABLE),
        function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        }
      );
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* ---- close bindings ------------------------------------------- */
    overlay.querySelectorAll('[data-zz-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    /* ---- desktop mega-switch -------------------------------------- */
    var railItems = overlay.querySelectorAll('.zz-menu__rail-item[data-zz-mega]');
    function activateMega(handle) {
      railItems.forEach(function (item) {
        var on = item.getAttribute('data-zz-mega') === handle;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      overlay.querySelectorAll('[data-zz-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-zz-panel') !== handle;
      });
    }
    railItems.forEach(function (item) {
      var handle = item.getAttribute('data-zz-mega');
      item.addEventListener('mouseenter', function () { activateMega(handle); });
      item.addEventListener('focus', function () { activateMega(handle); });
      item.addEventListener('click', function (e) {
        e.preventDefault();
        activateMega(handle);
      });
    });

    /* ---- desktop Produkte category hover -------------------------- */
    overlay.querySelectorAll('.zz-cat-row[data-zz-cat]').forEach(function (row) {
      var idx = row.getAttribute('data-zz-cat');
      var scope = row.getAttribute('data-zz-cat-scope');
      function activateCat() {
        // rows
        overlay
          .querySelectorAll('.zz-cat-row[data-zz-cat-scope="' + scope + '"]')
          .forEach(function (r) {
            r.classList.toggle('is-active', r === row);
          });
        // subcols
        overlay
          .querySelectorAll('.zz-subcol[data-zz-cat-scope="' + scope + '"]')
          .forEach(function (sc) {
            sc.hidden = sc.getAttribute('data-zz-subcol') !== idx;
          });
        // features
        overlay
          .querySelectorAll('.zz-feature[data-zz-cat-scope="' + scope + '"]')
          .forEach(function (ft) {
            ft.hidden = ft.getAttribute('data-zz-feature') !== idx;
          });
      }
      row.addEventListener('mouseenter', activateCat);
      row.addEventListener('focus', activateCat);
      row.addEventListener('click', activateCat);
    });

    /* ---- mobile drill --------------------------------------------- */
    var drillTitle = overlay.querySelector('[data-zz-drill-title]');
    function openDrill(idx, label) {
      overlay.querySelectorAll('[data-zz-drill-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-zz-drill-panel') !== idx;
      });
      if (drillTitle) drillTitle.textContent = label || '';
      if (mobile) mobile.classList.add('is-drilled');
      var stage = overlay.querySelector('.zz-menu__drill-stage');
      if (stage) stage.scrollTop = 0;
    }
    function resetMobileDrill() {
      if (mobile) mobile.classList.remove('is-drilled');
      overlay.querySelectorAll('[data-zz-drill-panel]').forEach(function (p) {
        p.hidden = true;
      });
    }
    overlay.querySelectorAll('.zz-mcat-row[data-zz-drill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrill(
          btn.getAttribute('data-zz-drill'),
          btn.querySelector('.zz-mcat-row__label')
            ? btn.querySelector('.zz-mcat-row__label').textContent
            : ''
        );
      });
    });
    overlay.querySelectorAll('[data-zz-drill-back]').forEach(function (b) {
      b.addEventListener('click', resetMobileDrill);
    });

    // expose for trigger binding
    overlay.__zzOpen = open;
    overlay.__zzClose = close;
    overlay.__zzActivateMega = activateMega;
  }

  /* Resolve a trigger's target to a rail-item handle.
     Accepts the exact data-zz-mega handle OR a word contained in the label. */
  function resolveMega(overlay, target) {
    var t = (target || '').trim().toLowerCase();
    if (!t) return null;
    var items = overlay.querySelectorAll('.zz-menu__rail-item[data-zz-mega]');
    var contains = null;
    for (var i = 0; i < items.length; i++) {
      var handle = items[i].getAttribute('data-zz-mega');
      if ((handle || '').toLowerCase() === t) return handle;
      var span = items[i].querySelector('span');
      var label = span ? span.textContent.trim().toLowerCase() : '';
      if (!contains && label && label.indexOf(t) !== -1) contains = handle;
    }
    return contains;
  }

  function triggersFor(overlay) {
    return Array.prototype.filter.call(
      document.querySelectorAll('[data-zz-menu-open]'),
      function (t) {
        var controls = t.getAttribute('aria-controls');
        return !controls || controls === overlay.id;
      }
    );
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* ---- global trigger delegation (works for header burgers too) --- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-zz-menu-open]');
    if (!trigger) return;
    var id = trigger.getAttribute('aria-controls');
    var overlay = id
      ? document.getElementById(id)
      : document.querySelector('[data-zz-menu]');
    if (!overlay) return;
    e.preventDefault();
    init(overlay);
    if (overlay.__zzOpen) overlay.__zzOpen();
    // optional: open a specific desktop panel
    var target = trigger.getAttribute('data-zz-menu-target');
    if (target && overlay.__zzActivateMega) {
      var handle = resolveMega(overlay, target);
      if (handle) overlay.__zzActivateMega(handle);
    }
  });

  function boot() {
    document.querySelectorAll('[data-zz-menu]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    var ov = e.target.querySelector
      ? e.target.querySelector('[data-zz-menu]')
      : null;
    if (ov) init(ov);
  });
})();
